import { Controller } from "@hotwired/stimulus"

// Map Overlay Controller
// Manages full-screen map overlay with filter synchronization from Grid
export default class extends Controller {
  static targets = ["overlay", "closeButton"]

  connect() {
    this.isOpen = false
  }

  disconnect() {
    // Cleanup if needed
    if (this.isOpen) {
      this.close()
    }
  }

  // Open overlay and sync filters from Grid
  open(event) {
    if (event) event.preventDefault()

    // Get active filters from grid-filter controller
    const gridFilterController = this.getGridFilterController()
    const activeFilters = gridFilterController ? gridFilterController.getActiveFilters() : null

    // Show overlay
    this.overlayTarget.classList.remove("hidden")
    this.isOpen = true

    // Prevent body scroll
    document.body.style.overflow = "hidden"

    // Apply filters to map after a short delay (let map initialize)
    setTimeout(() => {
      if (activeFilters) {
        this.applyFiltersToMap(activeFilters)
      }
    }, 500)
  }

  // Close overlay
  close(event) {
    if (event) event.preventDefault()

    // Hide overlay
    this.overlayTarget.classList.add("hidden")
    this.isOpen = false

    // Restore body scroll
    document.body.style.overflow = ""

    // Clear map filters (optional - or keep them for next open)
    // this.clearMapFilters()
  }

  // Close with ESC key
  closeWithKeyboard(event) {
    if (event.key === "Escape" && this.isOpen) {
      this.close()
    }
  }

  // Close when clicking backdrop (outside the map content)
  closeBackground(event) {
    // Only close if clicking directly on the overlay backdrop, not on child elements
    if (event.target === this.overlayTarget) {
      this.close()
    }
  }

  // Get grid-filter controller
  getGridFilterController() {
    const gridFilter = document.querySelector('[data-controller*="grid-filter"]')
    if (!gridFilter) return null

    return this.application.getControllerForElementAndIdentifier(gridFilter, "grid-filter")
  }

  // Get venues-map controller
  getVenuesMapController() {
    const venuesMap = this.element.querySelector('[data-controller*="venues-map"]')
    if (!venuesMap) return null

    return this.application.getControllerForElementAndIdentifier(venuesMap, "venues-map")
  }

  // Apply Grid filters to Map
  applyFiltersToMap(filters) {
    const mapController = this.getVenuesMapController()
    if (!mapController) return

    // Set search term
    if (filters.search && mapController.hasSearchInputTarget) {
      mapController.searchInputTarget.value = filters.search
    }

    // Set dropdown filters
    if (filters.filters) {
      // Country filter
      if (filters.filters.country && mapController.hasFilterCountryTarget) {
        mapController.filterCountryTarget.value = filters.filters.country
      }

      // City filter
      if (filters.filters.city && mapController.hasFilterCityTarget) {
        mapController.filterCityTarget.value = filters.filters.city
      }
    }

    // Trigger filter application
    if (mapController.filterVenues) {
      mapController.filterVenues()
    }
  }

  // Clear map filters (optional)
  clearMapFilters() {
    const mapController = this.getVenuesMapController()
    if (!mapController) return

    if (mapController.clearFilters) {
      mapController.clearFilters()
    }
  }
}
